export const environment = {
    RELEASE_STAGE: 'production',
    production: true,
    test: false,
    VERSION: require('../../package.json').version,
    FILE_UPLOAD_MAX_SIZE: 52428800,
    AUTHPASS: btoa('test:test'),
    ERROR_URL: '',
    ERROR_NOTIFY_ACTIVE: true,
    termalPrinter: {
        port: '8080',
    },
    service: {
        v1: {
            protocol: 'https://',
            rootUrl: 'app.eambulanta.si/booking',
            apiPort: '',
            apiUrl: '/erp/api',
        },
        v2: {
            protocol: 'https://',
            rootUrl: 'app.eambulanta.si/booking',
            apiPort: '',
            apiUrl: '/eav2/erp/api',
        },
    },
    auth: {
        protocol: 'https://',
        rootUrl: 'app.eambulanta.si/booking',
        port: '',
        url: '/oauth/token',
    },
    report: {
        protocol: 'https://',
        rootUrl: 'app.eambulanta.si/booking',
        port: '',
        url: '/erp/report1',
    },
    task: {
        protocol: 'https://',
        rootUrl: 'app.eambulanta.si/booking',
        port: '',
        url: '/eav2/erp/taskapi',
    },
    visit: {
        protocol: 'https://',
        rootUrl: 'app.eambulanta.si/booking',
        port: '',
        url: '/eav2/erp/visitapi',
    },
    patient: {
        protocol: 'https://',
        rootUrl: 'app.eambulanta.si/booking',
        port: '',
        url: '/patient/api',
    },
    assistance: {
        v1: {
            protocol: 'https://',
            rootUrl: 'app.eambulanta.si/booking',
            port: '',
            url: '/v2/assistance/api',
        },
        v2: {
            protocol: 'https://',
            rootUrl: 'app.eambulanta.si/booking',
            port: '',
            url: '/v2/assistance/api',
        },
        v3: {
            protocol: 'https://',
            rootUrl: 'app.eambulanta.si/booking',
            port: '',
            url: '/asv2/assistance/api',
        },
    },
    treatment: {
        protocol: 'https://',
        rootUrl: 'app.eambulanta.si/booking',
        port: '',
        url: '/erp/treatments',
    },
    root: {
        protocol: 'https://',
        rootUrl: 'app.eambulanta.si/booking',
        port: '',
        url: '',
    },
    agora: {
        appId: '74694d6ab72646fea80f43f17aab66b6',
        logLevel: 2,
    },
    webSocket: {
        protocol: 'wss://',
        rootUrl: 'app.eambulanta.si/booking',
        port: '',
        url: '/ws/ea',
    },
    webSocketTelemed: {
        protocol: 'wss://',
        rootUrl: 'app.eambulanta.si/booking',
        port: '',
        url: '/ws/telemed/',
    },
    toolsUrl: {
        protocol: 'https://',
        rootUrl: 'link.eambulanta.si/tools',
        port: '',
        url: '',
    },
};
